// import type {
//   SharedRecordPublic,
//   SharedRecords,
//   SharedSingleRecord,
//   SharedFile
// } from '../types/shared';

import type { Action } from '../types/actions';
import shareService from '../services/share-service';

// public resource info
function shareRequest(): Action { return { type: 'GET_SHARE_REQUEST' }; }
function shareSuccess(info): Action { return { type: 'GET_SHARE_SUCCESS', info }; }
function shareError(error): Action { return { type: 'GET_SHARE_ERROR', error }; }

// all shared resources
function sharedResourcesRequest(): Action { return { type: 'GET_SHARED_RESOURCES_REQUEST' }; }
function sharedResourcesSuccess(resources): Action { return { type: 'GET_SHARED_RESOURCES_SUCCESS', resources }; }
function sharedResourcesError(error): Action { return { type: 'GET_SHARED_RESOURCES_ERROR', error }; }

// single shared resource
function singleSharedResourceRequest(): Action { return { type: 'GET_SHARED_SINGLE_RESOURCE_REQUEST' }; }
function singleSharedResourceSuccess(resource): Action {
  return { type: 'GET_SHARED_SINGLE_RESOURCE_SUCCESS', resource };
}
function singleSharedResourceError(error): Action { return { type: 'GET_SHARED_SINGLE_RESOURCE_ERROR', error }; }

// single shared file info
function getSharedFile(): Action { return { type: 'GET_SHARED_FILE_REQUEST' }; }
function getSharedFileSuccess(file): Action { return { type: 'GET_SHARED_FILE_SUCCESS', file }; }
function getSharedFileError(error): Action { return { type: 'GET_SHARED_FILE_ERROR', error }; }

// single getSharedFile file info
function viewSharedThumbRequest(): Action { return { type: 'GET_SHARED_THUMB_REQUEST' }; }
function viewSharedThumbSuccess(file): Action { return { type: 'GET_SHARED_THUMB_SUCCESS', file }; }
function viewSharedThumbError(error): Action { return { type: 'GET_SHARED_THUMB_ERROR', error }; }

// single shared file
function viewSharedFileRequest(): Action { return { type: 'VIEW_SHARED_FILE_REQUEST' }; }
function viewSharedFileSuccess(file): Action { return { type: 'VIEW_SHARED_FILE_SUCCESS', file }; }
function viewSharedFileError(error): Action { return { type: 'VIEW_SHARED_FILE_ERROR', error }; }

// thunks

const fetchShare = (token: string) => (dispatch) => {
  dispatch(shareRequest());
  return shareService
    .getSharedResource(token: string)
    .then((info) => dispatch(shareSuccess(info)))
    .catch((error) => dispatch(shareError(error)));
};

const fetchSharedResources = (token: string) => (dispatch) => {
  dispatch(sharedResourcesRequest());
  shareService
    .getResources(token)
    .then((resources) => dispatch(sharedResourcesSuccess(resources)))
    .catch((error) => dispatch(sharedResourcesError(error)));
};

const fetchSingleSharedResource = (token: string, resourceID: number) => (dispatch) => {
  dispatch(singleSharedResourceRequest());
  shareService
    .getSingleResource(token, resourceID)
    .then((resource) => dispatch(singleSharedResourceSuccess(resource)))
    .catch((error) => dispatch(singleSharedResourceError(error)));
};

const fetchSharedFileInfo = (token: string, resourceID: number, fileID: number) => (dispatch) => {
  dispatch(getSharedFile());
  shareService
    .getFile(token, resourceID, fileID)
    .then((file) => dispatch(getSharedFileSuccess(file)))
    .catch((error) => dispatch(getSharedFileError(error)));
};

const fetchSharedFileThumb = (token: string, resourceID: number, fileID: number) => (dispatch) => {
  dispatch(viewSharedThumbRequest());
  shareService
    .viewThumb(token, resourceID, fileID)
    .then((file: Blob) => dispatch(viewSharedThumbSuccess(file)))
    .catch((error) => dispatch(viewSharedThumbError(error)));
};

const fetchSharedFile = (token: string, resourceID: number, fileID: number) => (dispatch) => {
  dispatch(viewSharedFileRequest());
  shareService
    .viewFile(token, resourceID, fileID)
    .then((file: Blob) => dispatch(viewSharedFileSuccess(file)))
    .catch((error) => dispatch(viewSharedFileError(error)));
};

export {
  fetchShare,
  fetchSharedResources,
  fetchSingleSharedResource,
  fetchSharedFileInfo,
  fetchSharedFileThumb,
  fetchSharedFile };


// WEBPACK FOOTER //
// ./src/actions/shared.js